import { Typography } from '@mui/material';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';

const ReportDisclaimer = () => {
  const { theme } = useThemeContext();
  return (
    <Typography
      variant="body2"
      sx={{
        fontSize: '12px',
        marginTop: '16px',
        color: theme.custom.report.details.infoSection.disclaimer.title.color,
      }}
    >
      Disclaimer:{' '}
      <Typography
        component="span"
        sx={{ color: theme.custom.report.details.infoSection.disclaimer.description.color, fontSize: '12px' }}
      >
        This test is intended to provide clinical information regarding the presence or absence of the specified PFAS
        compounds. Results should be interpreted in conjunction with other clinical and laboratory findings. The results
        of this test are not intended to be the sole basis for diagnosis or clinical decision-making. This test was
        developed and its performance characteristics determined by Relentless Health. It has not been cleared or
        approved by the US Food and Drug Administration.
      </Typography>
    </Typography>
  );
};

export default ReportDisclaimer;
